import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function ToggleButton(theme: Theme) {
  return {
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          border: `solid 1px ${theme.palette.grey[300]}`,
          fontWeight: 600,
        },
      },
    },
  };
}
